import { Repeat, TrendingUp, LineChart } from "lucide-react";
import { businessModel } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";

const icons = [Repeat, TrendingUp, LineChart];

export const BusinessModel = () => (
  <section id="business" data-testid="business-section" className="relative py-28 border-t border-white/5">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal className="max-w-2xl">
        <Overline>Business Model</Overline>
        <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
          Aligned incentives. <span className="text-brand-green">Shared success.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-3 gap-4">
        {businessModel.map((b, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full rounded-2xl border border-white/10 bg-surface/60 p-8 hover:-translate-y-1 hover:border-brand-cyan/40 transition-transform">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-cyan/10 border border-brand-cyan/20">
                  <Icon className="h-6 w-6 text-brand-cyan" />
                </div>
                <h3 className="mt-5 font-heading font-bold text-xl">{b.t}</h3>
                <p className="mt-2 text-white/60">{b.d}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
